"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

// https://www.cnblogs.com/pangguoming/p/7090906.html
function S4() {
  // eslint-disable-next-line
  return ((1 + Math.random()) * 0x10000 | 0).toString(16).substring(1);
} // Generate a pseudo-GUID by concatenating random hexadecimal.


var _default = function _default() {
  return "".concat(S4()).concat(S4(), "-").concat(S4(), "-").concat(S4(), "-").concat(S4(), "-").concat(S4()).concat(S4()).concat(S4());
};

exports.default = _default;